export const lavisFlatbreadPocket = {
  id: "lavisFlatbreadPocket",
  link: "/#/recipes/recipes/lavisFlatbreadPocket",
  name: "Lavis Flatbread Pockets",
  cuisine: "General",
  summary:
    "Small flatbread with a pocket, good for chunky curries or the like.",
  inspiration: "Gorditas",
  quantity: "12",
  time: "15 minutes",
  notes:
    "The books don't describe the flatbread that appears other than to say that, you know, it's flat. I didn't want to just use tortillas for everything, so I tried eating one of the curries with gorditas. Filling the pocket with a chunky curry turned out really well.",
  quotes:
    "Sadeas’s... meal still sat on the table, brass plate scattered with chunks of meat and torn flatbread. (The Way of Kings, ch 22)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/flatbread-pockets-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "maseca",
          display: "2 cups Mexican-style corn flour (Maseca)"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        },
        {
          item: "water",
          display: "1 1/2 cup water"
        }
      ]
    }
  ],
  steps: [
    "Combine all ingredients. Mix well. Let sit for 5 minutes - it can take a bit for the masa to absorb the water.",
    "The dough should be pliable, but wet enough to be pinched without cracking. If needed, add additional water to get the right consistency.",
    "Turn an electric nonstick griddle to high heat. Separate dough into 12 sections, and roll them into balls. Place one ball between two sheets of plastic. I like to use a plastic disposable shopping bag that I've cut down the side to open it up flat.",
    "Using a plate, press the dough ball flat until it's 4 inches wide. Place the dough patty on the griddle. Cook 15 seconds, then flip and cook 15 seconds more. Flip again and cook until the bottom has browned in just a few spots. Flip one last time and cook until the other side has browned in a few spots. At this point it should start to puff a bit, but it's okay if it doesn't. Remove from the griddle.",
    "Use a knife to cut along the edge, opening it up into a pocket. If dough puffed while cooking, this is simple. If not, just push the knife through the edge into the interior of the pocket and move the knife around to separate the two sides and push them apart. Scrape out any soft dough remaining inside. Serve with curry."
  ]
}
